import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layout'
import ActivityLayout from './activityLayout'
const Router = () => {
    return (
        <Routes>
            <Route path="/activity/*" element={<ActivityLayout/>} />
            <Route path="/*" element={<Layout />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    )
}

export default Router